import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div style={{ textAlign: 'center', paddingTop: '2rem' }}>
      <h1>404 — Page not found</h1>
      <p style={{ marginTop: '1rem' }}>
        <Link to="/">Back to home</Link>
      </p>
    </div>
  );
}
